import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {value: this.props.value};
    this.state.reactVersion = React.version;
  }
  onInputDateChange(event){
    document.getElementById("textinputdate").innerHTML = document.getElementById("inputdate").value;
  }
  
  onInputRangeChange(){
    document.getElementById("textinputrange").innerHTML = document.getElementById("inputrange").value;
  }
  
  onInputTextChange(){
    document.getElementById("textinputtext").innerHTML = document.getElementById("inputtext").value;
  }
  
  onInputNumberChange(){
    document.getElementById("textinputnumber").innerHTML = document.getElementById("inputnumber").value;
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">React Test Page</h1>
        </header>
        <table>
          <tbody>
            <tr>
              <td>Date:</td> 
              <td><input id="inputdate" className="inputbox" value={this.state.value} type="date" onChange={this.onInputDateChange}/></td>
              <td><div id="textinputdate" className="inputtext"></div></td>
            </tr>
            <tr>
              <td>Range: </td>
              <td><input id="inputrange" className="inputbox" type="range" onChange={this.onInputRangeChange}/></td>
              <td><div id="textinputrange" className="inputtext"></div></td>
            </tr>
            <tr>
              <td>Text: </td>
              <td><input id="inputtext" className="inputbox" type="text" onChange={this.onInputTextChange}/></td>
              <td><div id="textinputtext" className="inputtext"></div></td>
            </tr>
            <tr>
              <td>Number: </td>
              <td><input id="inputnumber" className="inputbox" type="number" onChange={this.onInputNumberChange}/></td>
              <td><div id="textinputnumber" className="inputtext"></div></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js